<style scoped>
::v-deep .text-external-urls {
    width: auto;
}
</style>

<template>
    <div>
        <div class="flex justify-center m-3 w-full" v-if="loading">
            <spinner />
        </div>
        <template v-else>
            <div class="sm:flex sm:flex-row w-full">
                <div class="w-full">
                    <breadcrumb :links="links" />
                    <productInfo
                        :product="product"
                        :productLinks="productLinks"
                        class="px-2 md:pl-16 md:pr-4 "
                    >
                        <div
                            class="flex text-sm text-gray-650 font-extrabold leading-none mb-2"
                            v-if="product.prodRefPrcAmt"
                        >
                            <div class="w-20 whitespace-no-wrap">
                                {{
                                    $t(
                                        'product.ref.prc.amt.' +
                                            product.prodTypeCode.toLowerCase()
                                    )
                                }}
                                :
                            </div>
                            <div>
                                {{ product.prodRefPrcAmt | price }}
                            </div>
                        </div>
                        <div class="flex text-xl leading-none mb-8">
                            <div
                                class="w-20 whitespace-no-wrap font-extrabold"
                                :class="{
                                    'text-red': isLessThanOrigPrcAmt,
                                    'text-darkGrayishBlue': !isLessThanOrigPrcAmt
                                }"
                            >
                                {{
                                    $t(
                                        'product.unit.prc.amt.' +
                                            product.prodTypeCode.toLowerCase()
                                    )
                                }}
                                :
                            </div>
                            <div
                                class="flex flex-grow items-end font-extrabold"
                                :class="{
                                    'text-red': isLessThanOrigPrcAmt,
                                    'text-darkGrayishBlue': !isLessThanOrigPrcAmt
                                }"
                            >
                                <div class="font-extrabold">
                                    {{
                                        (product.prodUnitPrcAmt || 0)
                                            | price(true)
                                    }}
                                </div>
                                <div
                                    class="font-extrabold text-gray-300 line-through text-sm ml-6 mt-2"
                                    v-if="isLessThanOrigPrcAmt"
                                >
                                    {{
                                        (product.prodOrigUnitPrcAmt || 0)
                                            | price
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="flex text-xl leading-none">
                            <div
                                class="w-20 pt-2 whitespace-no-wrap text-darkGrayishBlue"
                            >
                                {{ $t('product.qty') }} :
                            </div>
                            <div class="flex-1">
                                <quantityInput
                                    :max="9999"
                                    class="w-full bg-white"
                                />
                            </div>
                        </div>

                        <div class="w-full mt-8">
                            <buttonAddToCart
                                :disabled="true"
                                class="bg-secondary"
                                :product="product"
                            />
                        </div>
                    </productInfo>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import spinner from '@/components/spinner.vue';
import productInfo from '@/components/productInfo.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import { instance } from '@/utils/ajax';
import price from '@/components/priceFilter';
import quantityInput from '@/components/quantityInput.vue';
import buttonAddToCart from '@/components/buttonAddToCart.vue';
import ctx from '@/utils/ctx';

async function getProductByProdId(prodId) {
    try {
        const result = await instance.get(
            `/api/product/getPreviewDetail/${prodId}`
        );
        return result.data.data.product;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error get product by prodId');
    }
    return undefined;
}

export default {
    components: {
        spinner,
        productInfo,
        breadcrumb,
        quantityInput,
        buttonAddToCart
    },
    filters: { price },

    props: {
        breadcrumbPrependLinks: { type: Array, default: () => [] }
    },
    data() {
        return {
            loading: true,
            product: undefined,
            productLinks: [],
            tinyBlankGifImg:
                'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
        };
    },
    async mounted() {
        this.loading = true;
        const product = await getProductByProdId(this.$route.params.prodId);
        if (!product) {
            this.$router.push('/');
            return;
        }
        this.product = product;
        this.productLinks = product.prodLinkList || [];
        this.loading = false;
    },
    computed: {
        links() {
            const link = {
                text: this.$config.showProdName
                    ? this.product.prodName
                    : '產品資料'
            };
            return this.breadcrumbPrependLinks.concat([link]);
        },
        isLessThanOrigPrcAmt() {
            return this.$store.getters.isLessThanOrigPrcAmt(this.product);
        },
        advrtImageSrc() {
            return this.product.prodAdvrtImgId
                ? ctx('/advrtImage/' + this.product.prodAdvrtImgId)
                : '';
        }
    }
};
</script>
